export default "/_next/static/media/image-11-1024x361.672110afa8e714567ac64c8b2efc15f2.png";